import React from "react";
import { NewTab, PageTab } from "../../../../components";
import VmsOverview from "./VmsTabs/VmsOverview";
import VmsConfigure from "./VmsTabs/VmsConfigure";

const Vms = ({category, type, selectedModule}) => {
  const tabList = [
    {
      title: "Overview",
      page: <VmsOverview category={category} type={type} selectedModule={selectedModule} />,
      type: "main",
      //   id: "marketplace_insights",
    },
    {
      title: "Configure",
      page: <VmsConfigure category={category} type={type} selectedModule={selectedModule} />,
      type: "main",
      //   id: "marketplace_accounts",
    },
  ];
  return (
    <div className="flex flex-1">
      <NewTab
        tabs={tabList}
        color="black"
        variant="text"
        activeVariant="text"
      />
    </div>
  );
};

export default Vms;
